import axiosSetup from "../utils/axiosSetup";
import toast from "react-hot-toast";

export const uploadExcelData = async (
  data: any[],
  options?: { signal?: AbortSignal }
) => {
  try {
    const response = await axiosSetup.post("/leads/upload-excel", data, {
      signal: options?.signal,
    });
    return response.data;
  } catch (error: any) {
    toast.error("Error uploading Excel data:", error);
    throw error;
  }
};
